import React             from 'react';
import Select            from 'react-select';
import { CaretDownIcon } from '../icons/icons.jsx';

import './language-selector.scss';

export default class LanguageSelector extends React.Component {
    handleLocaleChange = ( locale ) => {
        this.props.onClick( { locale } );
    };

    render() {
        const {
            selectedLocale,
            options,
            id,
            tabIndex,
            selectRef
        } = this.props;

        return (
            <Select
                name="Language Preference"
                className= "language-selector"
                clearable={ false }
                autoFocus={ false }
                arrowRenderer={ () => <div className="icon"><CaretDownIcon /></div> }
                deleteRemoves={ false }
                backspaceRemoves={ false }
                value = { selectedLocale.code }
                valueKey="code"
                options={ options }
                onChange={ this.handleLocaleChange }
                inputProps={ { id: id, readOnly: true } }
                tabIndex={ tabIndex }
                ref={ selectRef }
            />
        );
    }
}
